/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  ComponentRendering,
  LayoutServiceData,
  withDatasourceCheck,
} from "@sitecore-jss/sitecore-jss-nextjs";
import { ComponentProps } from "lib/component-props";
import { GetServerSidePropsContext } from "next";

// import TemplateNavigation1, { NavigationCom } from "./TemplateComponents/TemplateNavigation1";
import TitleDescriptionImage1, {
  TitleDescriptionCom,
} from "./TemplateComponents/TitleDescriptionImage1";
// import Head from 'next/head';
import { useEffect, useState } from "react";
import QuestionAnswer, { QuestionAnswerCo } from "./TemplateComponents/QuestionAnswer";
import TimelineSection1, { TimelineSectionCo } from "./TemplateComponents/TimelineSection1";
import ImageDescriptionCard from "./TemplateComponents/ImageDescriptionCard/ImageDescriptionCard";
import CounterSection, { CounterSectionCo } from "./TemplateComponents/CounterSection";
import TitleDescriptionBtns, {
  TitleDescriptionBtnsCo,
} from "./TemplateComponents/TitleDescriptionBtns";
import AudioPlayerSection, { AudioPlayerSectionCo } from "./TemplateComponents/AudioPlayerSection";
import GalleryWithVerticalTitle, {
  GalleryWithVerticalTitleCo,
} from "./TemplateComponents/GalleryWithVerticalTitle";
import GalleryWithTitleAndRedirect, {
  GalleryWithTitleAndRedirectCo,
} from "./TemplateComponents/GalleryWithTitleAndRedirect";
import CardWithBottomImage, {
  CardWithBottomImageCo,
} from "./TemplateComponents/CardWithBottomImage";
import MediaCenterSection from "./TemplateComponents/MediaCenter/MediaCenterSection";
import SwiperCardWithBannerDescription, {
  SwiperCardWithBannerDescriptionCo,
} from "./TemplateComponents/SwiperCardWithBannerDescription";
import { HeroSectionCom } from "./TemplateComponents/HeroSection1/Helpers/HeroSection1types";
import HeroSection1 from "./TemplateComponents/HeroSection1/HeroSection1";
import { ImageDescriptionCardCo } from "./TemplateComponents/ImageDescriptionCard/Helpers/ImageDescriptionCardtypes";
import { InitiativeThreeColsMedCardSwiperSection } from "./TemplateComponents/ThreeColsMedCardsSwiper/InitiativeThreeColsMedCardSwiperSection";
import { InitiativeThreeColsLgCardsSwiper } from "./TemplateComponents/ThreeColsLgCardsSwiper/InitiativeThreeColsLgCardsSwiper";
import TimelineWithTabsAndTable, {
  TimelineWithTabsAndTableCo,
} from "./TemplateComponents/TimelineWithTabsAndTable/TimelineWithTabsAndTable";
import VotingSection, { VotingSectionCo } from "./TemplateComponents/VotingSection/VotingSection";
import {
  resolveVotingPollCountsForTemplate,
  TemplateSectionWithVoting,
  VotingPageMetaData,
  VotingPollCountsBySection,
} from "./TemplateComponents/VotingSection/Helpers/VotingSectionHelpers";

type TemplateDetailProps = ComponentProps & {
  fields: {
    Image: {
      value: {
        src: string;
        alt: string;
        width: string;
        height: string;
      };
    };
    Title: {
      value: string;
    };
    Description: {
      value: string;
    };
    Location: any;
    Region: {
      id: string;
      url: string;
      name: string;
      displayName: string;
      fields: {
        Title: {
          value: string;
        };
      };
    };
    FromDate: {
      value: string;
    };
    ToDate: {
      value: string;
    };
    Category: {
      id: string;
      url: string;
      name: string;
      displayName: string;
      fields: {
        Title: {
          value: string;
        };
      };
    };
    TemplatePageLink: {
      value: {
        href: string;
        text: string;
        anchor: string;
        linktype: string;
        class: string;
        title: string;
        target: string;
        querystring: string;
        id: string;
      };
    };
    EventPageLink: {
      value: {
        href: string;
        text: string;
        anchor: string;
        linktype: string;
        class: string;
        title: string;
        target: string;
        querystring: string;
        id: string;
      };
    };
    ShowAnimation: {
      value: boolean;
    };
    TemplateSections: (
      | HeroSectionCom
      // | NavigationCom
      | TitleDescriptionCom
      | QuestionAnswerCo
      | TimelineSectionCo
      | CounterSectionCo
      | TitleDescriptionBtnsCo
      | ImageDescriptionCardCo
      | GalleryWithVerticalTitleCo
      | GalleryWithTitleAndRedirectCo
      | AudioPlayerSectionCo
      | CardWithBottomImageCo
      | SwiperCardWithBannerDescriptionCo
      | TimelineWithTabsAndTableCo
      | VotingSectionCo
    )[];
    MetaBrowserTitle: {
      value: string;
    };
    Attributes: {
      value: string;
    };
    MetaDescription: {
      value: string;
    };
    MetaKeywords: {
      value: string;
    };
    DescriptionFontSize: {
      fields: {
        Title: {
          value: string;
        };
      };
    };
    PointsFontSize: {
      fields: {
        Title: {
          value: string;
        };
      };
    };
    TitleFontSize: {
      fields: {
        Title: {
          value: string;
        };
      };
    };
  };
  lang: string;
  locale: string;
  pageMetaData?: VotingPageMetaData;
  votingPollCountsBySection?: VotingPollCountsBySection;
};

const TemplateDetail = (props: TemplateDetailProps): JSX.Element => {
  const [scrollToArr, setScrollToArr] = useState<{ SectionId: string; ScrollToText: string }[]>([]);

  useEffect(() => {
    setScrollToArr([]);
    let temp: { SectionId: string; ScrollToText: string }[] = [];
    props?.fields?.TemplateSections?.length > 0 &&
      props?.fields?.TemplateSections.map((section: any) => {
        if (
          section.fields?.isScrollAllowed?.value &&
          section?.fields?.ScrollToText?.value &&
          section?.displayName != "Navigation"
        ) {
          temp = [...temp];
          temp.push({
            SectionId: section?.displayName,
            ScrollToText: section?.fields?.ScrollToText?.value,
          });
          setScrollToArr([...temp]);
        }
      });
  }, [props]);

  const renderSection = (sectionName: string, section: any, sectionIx: number) => {
    switch (sectionName) {
      // case "Navigation":
      //   return (
      //     <TemplateNavigation1
      //       fields={section?.fields}
      //       locale={props?.locale}
      //       SectionId={section?.displayName}
      //       ScrollTo={scrollToArr}
      //     />
      //   );

      case "HeroSection":
        return (
          <HeroSection1
            fields={section?.fields}
            locale={props?.locale}
            showAnimation={props?.fields?.ShowAnimation?.value}
            SectionId={section?.displayName}
            scrollToArr={scrollToArr || []}
          />
        );

      case "InformationAndRightImage":
        return (
          <TitleDescriptionImage1
            fields={section?.fields}
            locale={props?.locale}
            SectionId={section?.displayName}
            DescriptionFontSize={props?.fields?.DescriptionFontSize?.fields?.Title?.value}
          />
        );

      case "QuestionAnswer":
        return (
          <QuestionAnswer
            fields={section?.fields}
            locale={props?.locale}
            showAnimation={props?.fields?.ShowAnimation?.value}
            SectionId={section?.displayName}
            TitleFontSize={props?.fields?.TitleFontSize?.fields?.Title?.value}
            PointFontSize={props?.fields?.PointsFontSize?.fields?.Title?.value}
          />
        );

      case "Timeline":
        return (
          <TimelineSection1
            fields={section?.fields}
            locale={props?.locale}
            showAnimation={props?.fields?.ShowAnimation?.value}
            SectionId={section?.displayName}
            TitleFontSize={props?.fields?.TitleFontSize?.fields?.Title?.value}
            DescriptionFontSize={props?.fields?.DescriptionFontSize?.fields?.Title?.value}
          />
        );

      case "ImageDescriptionCard":
        return (
          <ImageDescriptionCard
            fields={section?.fields}
            locale={props?.locale}
            showAnimation={props?.fields?.ShowAnimation?.value}
            SectionId={section?.displayName}
            TitleFontSize={props?.fields?.TitleFontSize?.fields?.Title?.value}
            DescriptionFontSize={props?.fields?.DescriptionFontSize?.fields?.Title?.value}
            PointFontSize={props?.fields?.PointsFontSize?.fields?.Title?.value}
            sectionIx={sectionIx}
          />
        );

      case "Counter":
        return (
          <CounterSection
            fields={section?.fields}
            locale={props?.locale}
            showAnimation={props?.fields?.ShowAnimation?.value}
            SectionId={section?.displayName}
            TitleFontSize={props?.fields?.TitleFontSize?.fields?.Title?.value}
            DescriptionFontSize={props?.fields?.DescriptionFontSize?.fields?.Title?.value}
          />
        );

      case "TitleDescriptionBtns":
        return (
          <TitleDescriptionBtns
            fields={section?.fields}
            locale={props?.locale}
            SectionId={section?.displayName}
          />
        );

      case "AudioPlayer":
        return (
          <AudioPlayerSection
            sectionIx={sectionIx}
            fields={section?.fields}
            locale={props?.locale}
            showAnimation={props?.fields?.ShowAnimation?.value}
            SectionId={section?.displayName}
            TitleFontSize={props?.fields?.TitleFontSize?.fields?.Title?.value}
            DescriptionFontSize={props?.fields?.DescriptionFontSize?.fields?.Title?.value}
          />
        );

      case "GalleryWithVerticalTitle":
        return (
          <GalleryWithVerticalTitle
            fields={section?.fields}
            locale={props?.locale}
            showAnimation={props?.fields?.ShowAnimation?.value}
            SectionId={section?.displayName}
            TitleFontSize={props?.fields?.TitleFontSize?.fields?.Title?.value}
            DescriptionFontSize={props?.fields?.DescriptionFontSize?.fields?.Title?.value}
            sectionIx={sectionIx}
          />
        );

      case "GalleryWithTitleAndRedirect":
        return (
          <GalleryWithTitleAndRedirect
            fields={section?.fields}
            locale={props?.locale}
            showAnimation={props?.fields?.ShowAnimation?.value}
            SectionId={section?.displayName}
            TitleFontSize={props?.fields?.TitleFontSize?.fields?.Title?.value}
            DescriptionFontSize={props?.fields?.DescriptionFontSize?.fields?.Title?.value}
          />
        );

      case "CardWithBottomImage":
        return (
          <CardWithBottomImage
            fields={section?.fields}
            locale={props?.locale}
            showAnimation={props?.fields?.ShowAnimation?.value}
            SectionId={section?.displayName}
            TitleFontSize={props?.fields?.TitleFontSize?.fields?.Title?.value}
            DescriptionFontSize={props?.fields?.DescriptionFontSize?.fields?.Title?.value}
            PointFontSize={props?.fields?.PointsFontSize?.fields?.Title?.value}
            sectionIx={sectionIx}
          />
        );

      case "MediaCenter":
        return (
          <MediaCenterSection
            fields={section?.fields}
            locale={props?.locale}
            showAnimation={props?.fields?.ShowAnimation?.value}
            SectionId={section?.displayName}
            TitleFontSize={props?.fields?.TitleFontSize?.fields?.Title?.value}
            DescriptionFontSize={props?.fields?.DescriptionFontSize?.fields?.Title?.value}
            sectionIx={sectionIx}
          />
        );
      case "SwiperCardWithBannerDescription":
        // AKA: Two Columns Swiper Banner
        return (
          <SwiperCardWithBannerDescription
            fields={section?.fields}
            locale={props?.locale}
            showAnimation={props?.fields?.ShowAnimation?.value}
            SectionId={section?.displayName}
            TitleFontSize={props?.fields?.TitleFontSize?.fields?.Title?.value}
            DescriptionFontSize={props?.fields?.DescriptionFontSize?.fields?.Title?.value}
            PointFontSize={props?.fields?.PointsFontSize?.fields?.Title?.value}
            sectionIx={sectionIx}
          />
        );
      case "ThreeColsLgCardsSwiper":
        return (
          <InitiativeThreeColsLgCardsSwiper
            {...section}
            fields={section?.fields}
            locale={props?.locale}
            SectionId={section?.displayName}
            sectionIx={sectionIx}
          />
        );
      case "ThreeColsMedCardSwiper":
        return (
          <InitiativeThreeColsMedCardSwiperSection
            {...section}
            fields={section?.fields}
            locale={props?.locale}
            SectionId={section?.displayName}
            sectionIx={sectionIx}
          />
        );

      case "TimelineWithTabsAndTable":
        return (
          <TimelineWithTabsAndTable
            fields={section?.fields}
            locale={props?.locale}
            SectionId={section?.displayName}
          />
        );

      case "VotingSection":
        return (
          <VotingSection
            fields={section?.fields}
            locale={props?.locale}
            SectionId={section?.displayName}
            pollCounts={props.votingPollCountsBySection?.[section.id]}
            pageMetaData={{
              ...props?.pageMetaData,
              pageTitle: {
                value:
                  props?.pageMetaData?.pageTitle?.value ||
                  props?.fields?.MetaBrowserTitle?.value ||
                  props?.fields?.Title?.value ||
                  "",
              },
            }}
          />
        );

      default:
        return;
    }
  };
  return (
    <div>
      {/* <Head>
                <title>{props?.fields?.Title?.value ? props?.fields?.Title?.value + " - MOC" : " Detail - MOC"}</title>
             </Head> */}
      <div className={`flex flex-col overflow-hidden ${props?.locale == "ar" && "rtl"} `}>
        {props?.fields?.TemplateSections?.length > 0 &&
          props?.fields?.TemplateSections.map((section: any, sectionIx: number) => (
            <div key={section?.id}>
              {renderSection(
                section?.fields?.SectionTemplate?.fields?.Title?.value,
                section,
                sectionIx
              )}
            </div>
          ))}
      </div>
    </div>
  );
};

export const getServerSideProps = async (
  rendering: ComponentRendering,
  layoutData: LayoutServiceData,
  _context: GetServerSidePropsContext
) => {
  const templateSections =
    (rendering?.fields?.TemplateSections as TemplateSectionWithVoting[] | undefined) ??
    (layoutData?.sitecore?.route?.fields?.TemplateSections as TemplateSectionWithVoting[] | undefined);

  const votingPollCountsBySection = await resolveVotingPollCountsForTemplate(templateSections);

  if (!Object.keys(votingPollCountsBySection).length) {
    return {};
  }

  return { votingPollCountsBySection };
};

export default withDatasourceCheck()<TemplateDetailProps>(TemplateDetail);
